import React, { FC } from 'react';
import styled from 'styled-components';
import { micro } from '@westwing/ui-kit/typography';
import { forDesktop } from '@westwing/ui-kit/breakPoints';

const StyledBadgeCount = styled.span<{ count: number }>`
    ${micro}
    background: ${({ theme }) => theme.colors.charcoal100};
    border-radius: 50%;
    color: ${({ theme }) => theme.colors.white};
    min-width: 14px;
    height: 14px;
    position: absolute;
    bottom: 20px;
    left: 16px;
    padding: 1px 0 0 0;
    text-align: center;
    line-height: 12px;
    ${forDesktop`
        bottom: 21px;
        left: 16px;
    `}
    ${({ count }) =>
        count > 99
            ? `
            padding-left: 2px;
            `
            : ''}
`;

export interface LinkProps {
    count: number;
    counterTestId: string;
    className?: string;
}

export const Link: FC<LinkProps> = ({ count, counterTestId, className }): React.ReactElement => {
    return (
        <StyledBadgeCount count={count} data-testid={counterTestId} className={className}>
            {count > 99 ? `99+` : count}
        </StyledBadgeCount>
    );
};

export default Link;
